import React, { useEffect, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useNavigate } from 'react-router-dom'

import { FORM_ERROR } from 'final-form'
import jwtDecode from 'jwt-decode'

import { request } from '../api/apiCore'
import { useAuth } from '../auth/Auth'
import { Container } from '../components/Container'
import LoginForm from '../components/forms/LoginForm'
import Loader from '../components/ui/Loader'
import MailBoxLogin from '../components/users/MailBoxLogin'
import { APP_ENV } from '../constants/globals'
import { setItemToLocalStorage } from '../helpers/helpers'
import { redirectTo } from '../helpers/services'
import { useIdGobPeAcf } from '../hooks/useIdGobPe'
import { useLocationSearch } from '../hooks/useLocationSearch'

const verifyUser = async documentNumber =>
  await request({ url: `/users/verify-user?document_number=${documentNumber}` })

export const LoginPage = () => {
  const { dispatch } = useAuth()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { auth, getToken, getUser } = useIdGobPeAcf()
  const search = useLocationSearch()
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const onSubmit = async values => {
    try {
      const reCaptcha = await executeRecaptcha('login')
      if (!reCaptcha) return { [FORM_ERROR]: 'Error al validar reCaptcha' }

      if (values.codeSelected) {
        const user = await verifyUser(values.document_number)
        if (!user) return { [FORM_ERROR]: 'Verifica el DNI ingresado o regístrate para iniciar sesión' }

        dispatch({ type: 'Verification', payload: { ...values } })
        navigate('/iniciar-sesion-codigo', { replace: true })
      } else {
        const data = { document_type_code: 'dni', recaptcha: reCaptcha, ...values }
        const authenticate = await request({ url: '/authentication', method: 'POST', data })

        if (authenticate.response?.data.error) return { [FORM_ERROR]: authenticate.response.data.error }

        const { token: jwt } = authenticate
        const { user_id: id, name, father_last_name, document_number, ruc } = jwtDecode(jwt)

        dispatch({ type: 'Login', payload: { id, name, father_last_name, jwt, document_number, ruc, type: 'cue' } })
      }
    } catch (error) {
      return { [FORM_ERROR]: `Ocurrió un error: ${error}` }
    }
  }

  const idGobPeLogin = async () => {
    const idGobPeCode = search.code

    if (idGobPeCode) {
      setIsLoading(true)

      const { token: idGobPeToken, id_token: idGobPeIdToken } = await getToken(idGobPeCode)
      const { doc } = jwtDecode(idGobPeIdToken)

      const response = await verifyUser(doc)

      if (response) {
        const { token: jwt } = await getUser(idGobPeToken)
        const { user_id: id, name, father_last_name, document_number, ruc } = jwtDecode(jwt)

        dispatch({
          type: 'Login',
          payload: { id, name, father_last_name, jwt, document_number, ruc, type: 'idGobPe' }
        })
      } else {
        setItemToLocalStorage('idGobPeToken', idGobPeToken)
        navigate('/terminos-condiciones')
      }
    }
  }

  useEffect(() => {
    if (search.isSearching) return
    idGobPeLogin()
  }, [search])

  if (isLoading) return <Loader message="Espera un momento, estamos validando los datos ingresados." />

  return (
    <Container className="px-5 md:px-20">
      {APP_ENV === 'casilla' ? (
        <MailBoxLogin handleLogin={auth} />
      ) : (
        <LoginForm
          handleSubmitForm={onSubmit}
          handleIdPeruButton={() => redirectTo('IDPERULOG')}
          handleIdGobPeButton={auth}
        />
      )}
    </Container>
  )
}
